// Skills de la EMPRESA (`agent_skills`) — ADR-2026-09-09-el-agente-tiene-skills.
//
// Mismo patrón que `agentMemoryApi`: scopeado por empresa (RLS por `id_company`), se
// lee fresco en cada turno y se inyecta al catálogo del prompt. El agente escribe con
// `guardar_skill` (upsert por nombre); el usuario ve y borra desde el menú "⋯" → Skills.

import { supabase } from '../../../lib/supabase';
import { LIMITES_SKILL, type SkillDelAgente, type SkillNueva } from './skill';

interface FilaSkill {
  id: string;
  nombre: string;
  descripcion: string;
  cuando: string;
  cuerpo: string;
}

const aSkill = (f: FilaSkill): SkillDelAgente => ({
  id: f.id,
  nombre: f.nombre,
  descripcion: f.descripcion,
  cuando: f.cuando,
  cuerpo: f.cuerpo,
  origen: 'empresa',
});

/** Las skills de la empresa, más recientes primero. */
export async function fetchSkillsDeEmpresa(companyId: string): Promise<SkillDelAgente[]> {
  const { data, error } = await supabase
    .from('agent_skills')
    .select('id, nombre, descripcion, cuando, cuerpo')
    .eq('id_company', companyId)
    .order('updated_at', { ascending: false })
    .limit(LIMITES_SKILL.porEmpresa);
  if (error || !data) {
    if (error) console.error('[agentSkillsApi] fetchSkillsDeEmpresa', error);
    return [];
  }
  return (data as FilaSkill[]).map(aSkill);
}

/**
 * Guarda una skill de la empresa. Con el mismo nombre se sobrescribe: el índice único
 * (id_company, nombre) lo garantiza y el upsert lo usa. Devuelve la fila guardada o
 * null si falló.
 */
export async function guardarSkillDeEmpresa(
  companyId: string,
  skill: SkillNueva,
): Promise<SkillDelAgente | null> {
  const { data, error } = await supabase
    .from('agent_skills')
    .upsert(
      {
        id_company: companyId,
        nombre: skill.nombre,
        descripcion: skill.descripcion,
        cuando: skill.cuando,
        cuerpo: skill.cuerpo,
        updated_at: new Date().toISOString(),
      },
      { onConflict: 'id_company,nombre' },
    )
    .select('id, nombre, descripcion, cuando, cuerpo')
    .single();
  if (error || !data) {
    if (error) console.error('[agentSkillsApi] guardarSkillDeEmpresa', error);
    return null;
  }
  return aSkill(data as FilaSkill);
}

/** Borra una skill de la empresa por id. */
export async function borrarSkillDeEmpresa(id: string): Promise<void> {
  const { error } = await supabase.from('agent_skills').delete().eq('id', id);
  if (error) console.error('[agentSkillsApi] borrarSkillDeEmpresa', error);
}
